import styled from 'styled-components';

export const HolidayChip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  align-self: flex-start;
  margin: -8px 0 20px;
  padding: 5px 12px;
  background: #fff7e6;
  color: #92400e;
  border: 1px solid #fcd9a3;
  border-radius: 999px;
  font-family: 'Inter', sans-serif;
  font-size: 0.78rem;
  line-height: 1.2;

  svg {
    flex-shrink: 0;
  }
`;

export const DerivedHint = styled.span`
  margin-top: 4px;
  color: #6b7280;
  font-family: 'Inter', sans-serif;
  font-size: 0.72rem;
  line-height: 1.2;
`;
